/**
 * Web entry point for ZenBasket POS.
 *
 * Mirrors index.js (the Android/iOS entry) but mounts the very same <App />
 * through react-native-web's AppRegistry.runApplication instead of the native
 * AppRegistry bridge. All business logic, Redux state and screens are shared.
 *
 * @format
 */

import {AppRegistry} from 'react-native';

import App from './App';
// Default import: webpack exposes JSON modules by default export only.
import appConfig from './app.json';
import {loadWebFonts} from './src/platform/fonts/webFonts';
import {installErrorReporter} from './src/platform/devtools/errorReporter.web';
import {installGlobalStyles} from './src/platform/design/globalStyles.web';
import {startSessionPersistence} from './src/platform/auth/sessionStore.web';
import {installUnsavedSaleGuard} from './src/platform/root/unsavedSaleGuard.web';

const appName = appConfig.name;

// Dev-only: prints the real reason behind the dev-server overlay's
// "[object Object]" runtime errors. No-op in production builds.
installErrorReporter();

// react-native-vector-icons and the Montserrat family ship as .ttf files. On
// native they are linked by Gradle; on web they have to be registered as
// @font-face rules before the first render or icons show up as empty boxes.
loadWebFonts();

// Document-level web UI baseline: one font stack, one focus style, one
// stacking scale. Everything react-native styles cannot express.
// See src/platform/design/globalStyles.web.ts.
installGlobalStyles();

// Mirrors the store/role the session was bootstrapped with to localStorage,
// so a browser refresh can put the session back instead of dropping the user
// on the sign-in screen. See src/platform/auth/sessionStore.web.ts.
startSessionPersistence();

// The cart is not persisted, so ask before a refresh / tab close drops a sale
// in progress. See src/platform/root/unsavedSaleGuard.web.ts.
installUnsavedSaleGuard();

AppRegistry.registerComponent(appName, () => App);

AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
